import SubscribePlease from './SubscribePlease';

export default SubscribePlease;
